import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.css']
})
export class InfoModalComponent {
  @ViewChild('classic') public templateRef: TemplateRef<any>;
  message: string;
  title: string;
  success = true;
  modalReference: NgbModalRef;

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true
  };

  constructor(private modalService: NgbModal) { }

  async open(title: string, msg: string, success: boolean, wide?: boolean): Promise<boolean> {
    this.success = success;
    this.title = title;
    this.message = msg;
    if (wide) {
      this.ngbModalOptions.size = 'md'
    } else {
      this.ngbModalOptions.size = 'sm';
    }
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
    return await this.modalReference.result.then();
  }

}
